import AudioIcon from '@mui/icons-material/Audiotrack'
import ImageIcon from '@mui/icons-material/Image'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import YouTubeIcon from '@mui/icons-material/YouTube'
import { Box, Stack } from '@mui/material'
import { green, grey, orange, red } from '@mui/material/colors'
import { PLACEHOLDER } from 'components/column-renderers'

export function UIContentIcons({
  isPublished,
  hasVideo,
  hasImage,
  hasAudio,
  showPublished = true,
}: {
  isPublished?: boolean
  hasVideo?: boolean
  hasImage?: boolean
  hasAudio?: boolean
  showPublished?: boolean
}) {
  const iconSX = { fontSize: '1.5rem' }

  return (
    <Box display="flex" height="42px" alignItems="center">
      <Stack direction="row" spacing={1}>
        {showPublished && isPublished && <VisibilityIcon sx={{ ...iconSX, color: grey[800] }} />}
        {showPublished && !isPublished && (
          <VisibilityOffIcon sx={{ ...iconSX, color: grey[600] }} />
        )}

        {hasImage && <ImageIcon sx={{ ...iconSX, color: orange[400] }} />}

        {hasVideo && <YouTubeIcon sx={{ ...iconSX, color: red[700] }} />}

        {hasAudio && <AudioIcon sx={{ ...iconSX, color: green[700] }} />}

        {!showPublished && !hasImage && !hasVideo && !hasAudio && PLACEHOLDER}
      </Stack>
    </Box>
  )
}
